/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { trackedReset } from 'tracked-toolbox';
import { action } from '@ember/object';
import { type InspectItem } from './inspect-sections';
import { inject as service } from '@ember/service';

interface SectionComponentArgs {
  questionId?: number;
  sectionId: string;
  items: InspectItem[];
  title: string;
}

type SectionComponentSignature = {
  Args: SectionComponentArgs;
  Element: HTMLDivElement;
};

export default class Section extends Component<SectionComponentSignature> {
  @service intercomEventService: $TSFixMe;

  @trackedReset('args.questionId') openSectionId = '';
  @trackedReset('args.questionId') viewingAllItems = false;

  get firstThreeItems() {
    return this.args.items?.slice(0, 3);
  }

  get remainingItems() {
    return this.args.items?.slice(3);
  }

  @action toggleSection() {
    let sectionId = this.args.sectionId;
    let isOpen = this.openSectionId === sectionId;
    this.openSectionId = isOpen ? '' : sectionId;
  }

  @action trackAccordionClicks() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'section_accordion',
      context: 'playground',
      accordion_type: this.args.sectionId,
      open_or_closed: this.openSectionId === this.args.sectionId ? 'open' : 'closed',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::FinAnswer::Inspect::Section': typeof Section;
  }
}
